// extracted by mini-css-extract-plugin
export var modal = "_bi-0";